module.exports = __webpack_public_path__ + "img/Kerala_tree.11f01680.gif";